import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { EIcon } from '@shared/enums/icon.enum';
import { UserData } from '@shared/interfaces/user-data';
import { RestUserModel } from '@shared/interfaces/user.interface';
import { AvatarService } from '@ui-components/components/avatar/services/avatar.service';

export const AVATAR_COLOR_THEMES_LIST = [
  'theme-1',
  'theme-2',
  'theme-3',
  'theme-4',
  'theme-5',
  'theme-6',
  'theme-7',
  'theme-8',
  'theme-9',
  'theme-10',
  'theme-11',
  'theme-12',
  'theme-13',
  'theme-14',
  'theme-15',
  'theme-16',
];

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent extends ComponentAbstract {
  readonly SYSTEM_USER_ID = 1;

  userId = 0;
  fullName = '';
  firstName = '';
  lastName = '';
  avatarTheme = 'default';

  @Input() set userInfo(userInfo: RestUserModel | UserData) {
    this.avatarTheme = this.avatarService.getUserConfig(userInfo?.id);
    this.userId = userInfo?.id;

    if (this.useFullName && 'name' in userInfo) {
      this.fullName = userInfo.name;
      const [first, ...rest] = userInfo.name.trim().split(' ');
      this.firstName = first || '?';
      this.lastName = rest.join(' ') || '?';
    } else if (this.useFullName && 'displayName' in userInfo) {
      if (userInfo?.id === this.SYSTEM_USER_ID) {
        this.avatarTheme = 'system';
        this.firstName = 'System';
        this.lastName = '';
      } else {
        const [first, ...rest] = userInfo.displayName.trim().split(' ');
        this.firstName = first || '?';
        this.lastName = rest.join(' ') || '?';
      }
    } else {
      if (userInfo?.id === this.SYSTEM_USER_ID) {
        this.avatarTheme = 'system';
        this.firstName = 'System';
        this.lastName = '';
      } else {
        this.firstName = userInfo?.firstName || '?';
        this.lastName = userInfo?.lastName || '?';
      }

      this.setFullName();
    }
  }

  @Input() containerCss = '';
  @Input() icon: EIcon;
  @Input() iconSize = 24;
  @Input() useFullName = false;
  @Input() showFullName = false;
  @Input() showMatTooltip = false;
  @Input() showIcon = true;
  @Input() disableTooltip = false;
  @Input() isUpperCase = true;
  @Input() customTooltip = '';

  constructor(protected cdr: ChangeDetectorRef, private avatarService: AvatarService) {
    super(cdr);
  }

  private setFullName() {
    this.fullName = `${this.firstName || ''} ${this.lastName || ''}`;
    this.cdr.markForCheck();
  }
}
